import { Component, Inject, Input, OnChanges, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Subscription } from 'rxjs';
import { CountrydetailpageService } from '../countrydetailpage.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';

@Component({
  selector: 'app-country-detail-other-countries',
  templateUrl: './country-detail-other-countries.component.html',
  styleUrls: ['./country-detail-other-countries.component.scss'],
  imports: [CommonModule, UrlParamsPipe],
})
export class CountryDetailOtherCountriesComponent implements OnInit, OnDestroy, OnChanges {
  @Input() pageData: any;
  activeTabIndex = 0;
  continentTabs: any;
  queryParams: any;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private contentful: ContentfulService,
    private countryDetailPageService: CountrydetailpageService,
    private router: ActivatedRoute
  ) {
    this.subscriptions = [];
    this.router.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  coverageData: any;

  ngOnInit(): void {
    this.countryDetailPageService.coverage$.subscribe(data => {
      
    });
  }
  ngOnChanges(): void {
    if (!this.pageData) return;
    const data = this.pageData?.coverage?.fields;
    if (data != null && this.pageData?.coverage) {
      this.coverageData = {
        tabs: data.component1,
        header: data.title,
      };
      this.continentTabs = this.coverageData?.tabs?.map((el:any) => el.fields?.tagText) || [];
      const isServer = !isPlatformBrowser(this.platformId);
      if (isServer) return;
      this.router.params.subscribe(params => {
        const continent = params['continent']?.split('-')?.join(' ') || '';
        const index = this.continentTabs?.indexOf(continent);
        if(index > -1){
          this.activeTabIndex = index;
        }
      });
    }
  }
  openPage(url: string) {
    if (url) {
      let link = 'Coverage/Countries/' + url;
      window.open(link, '_self');
    } else {
      return;
    }
  }
  tabHandler(index: number) {
    this.activeTabIndex = index;
  }
  openLink(event:any, target?:string) {
    event.preventDefault();
    const link = event.target.attributes.href.value;
    const searchParams = location.search !== '' ? location.search.slice(1) : '';
    let linkHasParams = new URLSearchParams(link) as any;
    let url = link;
    if(searchParams !== ''){
      if(linkHasParams.search > 0){
        url = `${link}&${searchParams}`;
      }else{
        url = `${link}?${searchParams}`;
      }
    }
    window.open(url, target || '_self');
  }
}
